export default __webpack_public_path__ + "static/banner-3cb5ed6d308545dbee34a2ec983200fb.svg";